import { Box, Checkbox, FormControlLabel, TextField } from "@mui/material";
import AddOrEditBasicEntity from "../../../components/common/AddOrEditBasicEntity";
import { useState } from "react";
import localize from "../../../common/localize";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";

export default function AddOrEditFinishConcept({ model, setModel }) {
  const handleValueChange = (e) => {
    if (!e) {
      setModel({ ...model, Value: 0 });
      return;
    }

    setModel({ ...model, Value: e.target.value < 0 ? 0 : e.target.value });
  };

  const handleChange = (e) => {
    if (!e) {
      setModel({ ...model, ReplaceServiceValue: false });
      return;
    }

    setModel({ ...model, ReplaceServiceValue: e.target.checked });
  };

  const getCustomComponents = () => {
    return (
      <Box className="flex flex-col gap-4">
        <FormControlLabel
          size="small"
          name="ReplaceServiceValue"
          control={
            <Checkbox
              size="small"
              name="ReplaceServiceValue"
              checked={model.ReplaceServiceValue ?? false}
              onChange={handleChange}
            />
          }
          label={
            <span style={{ fontSize: "0.8em" }}>
              <PageTitleSubtitle
                title={localize.replace_service_value}
                subtitle={localize.replace_service_value_Description}
                useEventTitleStyle
                useFieldTitleStyle
              />
            </span>
          }
        />

        {model?.ReplaceServiceValue && (
          <TextField
            type="number"
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            value={model.Value ?? 0}
            onChange={handleValueChange}
            size="small"
            id="model_value"
            name="model_value"
            label={localize.value}
            variant="outlined"
            fullWidth
          />
        )}
      </Box>
    );
  };

  return (
    <AddOrEditBasicEntity
      customWidth="100%"
      model={model}
      setModel={setModel}
      nameMandatory
      customComponent={getCustomComponents()}
    />
  );
}
